import React from "react";
import { PORTRAIT_BASE } from "./copy";

interface PortraitProps {
  /** Rendered size in CSS pixels. The 200px source covers 2× density up to 100px. */
  size: number;
  className?: string;
  alt?: string;
}

// The evening-headshot family already used by the homepage hero card; usage is registered in
// public/images/jorge-giraldez/IN-USE.md.
const Portrait: React.FC<PortraitProps> = ({ size, className = "", alt = "" }) => (
  <picture>
    <source type="image/avif" srcSet={`${PORTRAIT_BASE}-200.avif`} />
    <source type="image/webp" srcSet={`${PORTRAIT_BASE}-200.webp`} />
    <img
      src={`${PORTRAIT_BASE}-200.jpg`}
      width={size}
      height={size}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={`rounded-full object-cover shrink-0 ${className}`}
      style={{ width: size, height: size }}
    />
  </picture>
);

export default Portrait;
